import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  getMetaDataArea,
  getMetaDataDistrict,
  getMetaDataSchool,
  getMetaDataState,
  getUserAnalytics,
  getUserAndRoleAnalytics
} from '../../redux/reducers/analyticsSlice';
import {
  Box,
  Dialog,
  DialogContent,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Skeleton,
  SvgIcon,
  Tooltip,
  Typography
} from '@mui/material';
import {
  Calendar01Icon,
  Expand05Icon,
  FileDownload03Icon,
  FilterLinesIcon,
  User01Icon,
  XClose
} from '../../utils/iconSvg';
import { isArrayNotEmpty } from '../../utils/utils';
import { useSelector } from 'react-redux';
import {
  colorPrimary,
  colorSecondary,
  colorTextBlack
} from '../../config/theme';
import {
  Legend,
  prepareChartOptionsAndData,
  prepareChartOptionsAndData2,
  styledMenuItem,
  StyledSelect
} from '../productanalytics/UserAndRoleAnalytics';
import dayjs from 'dayjs';
import { HighlightOff } from '@mui/icons-material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Chart from 'react-google-charts';
import { useLocation } from 'react-router-dom';

const SelectStyled = {
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#CBD2D9'
  },
  '&:hover  .MuiOutlinedInput-notchedOutline': {
    borderColor: '#CBD2D9'
  },
  '&.Mui-focused  .MuiOutlinedInput-notchedOutline': {
    borderColor: '#CBD2D9'
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: 8
  }
};
const ShareUserAndRoleAnalytics = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  let chartType = new URLSearchParams(location.search).get('chartType');

  const [tempDateFilter, setTempDateFilter] = useState({
    dateType: null,
    startDate: null,
    endDate: null
  });
  const [open, setOpen] = useState(null);
  const [chart1Payload, setChart1Payload] = useState({
    userStatusType: -999,
    roleStatusType: -999,
    userGroupStatusType: null,
    stateId: 'all',
    districtId: 'all',
    area: 'all',
    dateType: 'all',
    startDate: null,
    endDate: null
  });
  const [chart, setChart] = useState('');
  const [chart2Payload, setChart2Payload] = useState({
    userStatusType: -999,
    dateType: 'all',
    startDate: null,
    endDate: null
  });
  const [chart1Wrapper, setChart1Wrapper] = useState(null);
  const [chart2Wrapper, setChart2Wrapper] = useState(null);

  const {
    isUserAndRoleAnalyticsLoading,
    userAndRoleAnalyticsData,
    userAnalyticsData,
    metaDataState,
    metaDataDistrict,
    metaDataArea,
    isMetaDataStateSuccess,
    isMetaDataDistrictSuccess,
    isMetaDataAreaSuccess
  } = useSelector(state => state.analytics);

  useEffect(() => {
    let mastersPayload = {
      type: 'all',
      page: 0,
      size: 0,
      search: ''
    };
    dispatch(getMetaDataState(mastersPayload));
    dispatch(getMetaDataDistrict(mastersPayload));
    dispatch(getMetaDataArea(mastersPayload));
    dispatch(getMetaDataSchool(mastersPayload));
  }, []);

  useEffect(() => {
    if (
      isMetaDataStateSuccess &&
      isMetaDataDistrictSuccess &&
      isMetaDataAreaSuccess
    ) {
      let params = new URLSearchParams(location.search);
      if (chartType == 'userAndRoleChart') {
        let payloadForChart1 = {
          userStatusType: params.get('userStatus'),
          roleStatusType: params.get('roleStatus'),
          stateId: params.get('state'),
          districtId: params.get('district'),
          area: params.get('area'),
          dateType: params.get('dateType'),
          startDate: params.get('startDate'),
          endDate: params.get('endDate')
        };

        setChart1Payload({
          ...chart1Payload,
          userStatusType:
            payloadForChart1.userStatusType == 'true'
              ? true
              : payloadForChart1.userStatusType == 'false'
                ? false
                : payloadForChart1.userStatusType == '-999'
                  ? -999
                  : payloadForChart1.userStatusType,
          roleStatusType:
            payloadForChart1.roleStatusType == 'true'
              ? true
              : payloadForChart1.roleStatusType == 'false'
                ? false
                : payloadForChart1.roleStatusType == '-999'
                  ? -999
                  : payloadForChart1.roleStatusType,
          stateId:
            payloadForChart1.stateId != 'all'
              ? +payloadForChart1.stateId
              : 'all',
          districtId:
            payloadForChart1.districtId != 'all'
              ? +payloadForChart1.districtId
              : 'all',
          area: payloadForChart1.area != 'all' ? +payloadForChart1.area : 'all',
          dateType: payloadForChart1.dateType,
          startDate: payloadForChart1.startDate,
          endDate: payloadForChart1.endDate
        });
      }

      if (chartType == 'usersChart') {
        let payloadForChart2 = {
          userStatusType: params.get('userStatus'),
          dateType: params.get('dateType'),
          startDate: params.get('startDate'),
          endDate: params.get('endDate')
        };
        console.log(payloadForChart2.dateType, 'dateType');
        setChart2Payload({
          ...chart2Payload,
          userStatusType:
            payloadForChart2.userStatusType == 'true'
              ? true
              : payloadForChart2.userStatusType == 'false'
                ? false
                : payloadForChart2.userStatusType == '-999'
                  ? -999
                  : payloadForChart2.userStatusType,
          dateType: payloadForChart2.dateType,
          startDate: payloadForChart2.startDate,
          endDate: payloadForChart2.endDate
        });
      }
    }
    return () => {
      // second;
    };
  }, [
    isMetaDataStateSuccess,
    isMetaDataDistrictSuccess,
    isMetaDataAreaSuccess
  ]);

  useEffect(() => {
    if (chartType == 'userAndRoleChart') {
      let payload = {
        ...chart1Payload,
        userStatusType:
          chart1Payload.userStatusType == -999
            ? 'all'
            : chart1Payload.userStatusType,
        roleStatusType:
          chart1Payload.roleStatusType == -999
            ? 'all'
            : chart1Payload.roleStatusType,
        stateId: chart1Payload.stateId == 'all' ? null : chart1Payload.stateId,
        districtId:
          chart1Payload.districtId == 'all' ? null : chart1Payload.districtId,
        area: chart1Payload.area == 'all' ? null : chart1Payload.area,
        dateType: chart1Payload.dateType,
        startDate: chart1Payload.startDate
          ? dayjs(chart1Payload.startDate).format('YYYY-MM-DD')
          : null,
        endDate: chart1Payload.endDate
          ? dayjs(chart1Payload.endDate).format('YYYY-MM-DD')
          : null
      };
      dispatch(getUserAndRoleAnalytics(payload));
    }
  }, [chart1Payload]);

  useEffect(() => {
    if (chartType == 'usersChart') {
      let payload = {
        userStatusType:
          chart2Payload.userStatusType == -999
            ? 'all'
            : chart2Payload.userStatusType,
        dateType: chart2Payload.dateType,
        startDate: chart2Payload.startDate
          ? dayjs(chart2Payload.startDate).format('YYYY-MM-DD')
          : null,
        endDate: chart2Payload.endDate
          ? dayjs(chart2Payload.endDate).format('YYYY-MM-DD')
          : null
      };

      dispatch(getUserAnalytics(payload));
    }
  }, [chart2Payload]);

  const handleClickOpen = id => {
    setChart(id);
  };

  const handleClose = () => {
    setChart('');
  };

  const options = {
    hAxis: {
      title: 'Date',
      titleTextStyle: {
        fontSize: 14,
        color: '#ABB4BD',
        italic: false,
        bold: true
      }
    },
    vAxis: {
      title: 'Count',
      titleTextStyle: {
        fontSize: 14,
        color: '#ABB4BD',
        italic: false,
        bold: true
      },
      viewWindow: {
        min: 0
      },
      ticks: prepareChartOptionsAndData(userAndRoleAnalyticsData.analyticsData),
      gridlines: {
        count: 10,
        color: '#F5F7FA',
        units: {
          ones: { count: 0 }
        }
      }
    },
    curveType: 'function',
    series: {
      0: { color: colorPrimary, curveType: 'function' },
      1: { color: '#2F68C4', curveType: 'function' },
      2: { color: '#749E35', curveType: 'function' }
    },
    legend: { position: 'none' }
  };

  const options2 = {
    hAxis: {
      title: 'Date',
      titleTextStyle: {
        fontSize: 14,
        color: '#ABB4BD',
        italic: false,
        bold: true
      }
    },
    vAxis: {
      title: 'Count',
      titleTextStyle: {
        fontSize: 14,
        color: '#ABB4BD',
        italic: false,
        bold: true
      },
      viewWindow: {
        min: 0
      },
      ticks: prepareChartOptionsAndData2(userAnalyticsData.analyticsData),
      gridlines: {
        count: 10,
        color: '#F5F7FA',
        units: {
          ones: { count: 0 }
        }
      }
    },
    curveType: 'function',
    series: {
      0: { color: colorPrimary, curveType: 'function' },
      1: { color: '#2F68C4', curveType: 'function' },
      2: { color: '#749E35', curveType: 'function' }
    },
    legend: { position: 'none' }
  };

  const handleDownload = ({ id = null }) => {
    if (id) {
      const chartWrapper =
        (id === 1 && chart1Wrapper) || (id === 2 && chart2Wrapper);
      const imageURI = chartWrapper.getChart().getImageURI();
      const link = document.createElement('a');
      link.href = imageURI;
      link.download = 'chart.png';
      link.click();
    }
  };

  return (
    <Grid item>
      <Typography mb={2} variant="h5" fontWeight={'600'}>
        User and Role Analytics
      </Typography>
      {chartType == 'userAndRoleChart' && (
        <Grid
          mt={2}
          container
          display={'flex'}
          width={'100%'}
          flexDirection={'column'}
          sx={{ borderRadius: '8px', padding: 2, bgcolor: 'white' }}
        >
          <Grid item display={'flex'} mb={1}>
            <Grid container display={'flex'} mb={1}>
              <Grid xs={12} lg={1.9} sm={12} md={6} mr={1} mb={1}>
                <FormControl fullWidth>
                  <Select
                    placeholder="Role status"
                    size="small"
                    value={chart1Payload.roleStatusType}
                    onChange={e =>
                      setChart1Payload({
                        ...chart1Payload,
                        roleStatusType: e.target.value
                      })
                    }
                    sx={SelectStyled}
                    renderValue={val => {
                      return val === -999 ? (
                        <Typography
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            color: '#ABB4BD'
                          }}
                        >
                          <SvgIcon fontSize="small" sx={{ marginRight: 1 }}>
                            <User01Icon color="#ABB4BD" />
                          </SvgIcon>
                          Role status
                        </Typography>
                      ) : val === true ? (
                        'Active Roles'
                      ) : val === false ? (
                        'Inactive Roles'
                      ) : (
                        'All Roles'
                      );
                    }}
                  >
                    <MenuItem value={'all'}>All Roles</MenuItem>
                    <MenuItem value={true}>Active Roles</MenuItem>
                    <MenuItem value={false}>Inactive Roles</MenuItem>
                  </Select>
                </FormControl>
              </Grid>{' '}
              <Grid xs={12} lg={1.9} sm={12} md={6} mr={1} mb={1}>
                <FormControl fullWidth>
                  <Select
                    placeholder="User status"
                    size="small"
                    value={chart1Payload.userStatusType}
                    onChange={e =>
                      setChart1Payload({
                        ...chart1Payload,
                        userStatusType: e.target.value
                      })
                    }
                    sx={SelectStyled}
                    renderValue={val => {
                      return val === -999 ? (
                        <Typography
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            color: '#ABB4BD'
                          }}
                        >
                          <SvgIcon fontSize="small" sx={{ marginRight: 1 }}>
                            <User01Icon color="#ABB4BD" />
                          </SvgIcon>
                          User status
                        </Typography>
                      ) : val === true ? (
                        'Active Users'
                      ) : val === false ? (
                        'Inactive Users'
                      ) : (
                        'All Users'
                      );
                    }}
                  >
                    <MenuItem value={'all'}>All Users</MenuItem>
                    <MenuItem value={true}>Active Users</MenuItem>
                    <MenuItem value={false}>Inactive Users</MenuItem>
                  </Select>
                </FormControl>{' '}
              </Grid>{' '}
              <Grid xs={12} lg={1.9} sm={12} md={6} mr={1} mb={1}>
                <FormControl fullWidth>
                  <Select
                    size="small"
                    value={chart1Payload.stateId}
                    onChange={e => {
                      console.log(e.target.value, 'vale');
                      setChart1Payload({
                        ...chart1Payload,
                        stateId: e.target.value,
                        districtId: 'all',
                        area: 'all'
                      });
                    }}
                    sx={SelectStyled}
                    renderValue={val => {
                      let value =
                        isArrayNotEmpty(metaDataState) &&
                        metaDataState.find(row => row.stateId === val);

                      return val === 'all' ? (
                        <Typography
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            color: '#ABB4BD'
                          }}
                        >
                          Select state
                        </Typography>
                      ) : (
                        value?.stateName
                      );
                    }}
                  >
                    {isArrayNotEmpty(metaDataState) &&
                      metaDataState.map((row, key) => {
                        return (
                          <MenuItem
                            key={key}
                            value={row.stateId}
                            sx={{
                              ':hover': {
                                backgroundColor: colorSecondary
                              }
                            }}
                          >
                            {row?.stateName}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>{' '}
              </Grid>{' '}
              <Grid xs={12} lg={1.9} sm={12} md={6} mr={1} mb={1}>
                <FormControl fullWidth>
                  <Select
                    size="small"
                    value={chart1Payload.districtId}
                    onChange={e =>
                      setChart1Payload({
                        ...chart1Payload,
                        districtId: e.target.value,
                        area: 'all'
                      })
                    }
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#CBD2D9'
                      },
                      '&:hover  .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#CBD2D9'
                      },
                      '&.Mui-focused  .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#CBD2D9'
                      },
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 8
                      }
                    }}
                    renderValue={val => {
                      let value =
                        isArrayNotEmpty(metaDataDistrict) &&
                        metaDataDistrict.find(
                          (row, key) => row.districtId === val
                        );

                      return val === 'all' ? (
                        <Typography
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            color: '#ABB4BD'
                          }}
                        >
                          Select district
                        </Typography>
                      ) : (
                        value?.districtName
                      );
                    }}
                  >
                    {isArrayNotEmpty(metaDataDistrict) &&
                      metaDataDistrict
                        .filter(cc => cc.stateId === chart1Payload.stateId)
                        .map((row, key) => {
                          return (
                            <MenuItem
                              key={key}
                              value={row?.districtId}
                              sx={{
                                ':hover': {
                                  backgroundColor: colorSecondary
                                }
                              }}
                            >
                              {row?.districtName}
                            </MenuItem>
                          );
                        })}
                  </Select>
                </FormControl>{' '}
              </Grid>{' '}
              <Grid xs={12} lg={1.9} sm={12} md={6} mr={1} mb={1}>
                <FormControl fullWidth>
                  <Select
                    size="small"
                    value={chart1Payload.area}
                    onChange={e =>
                      setChart1Payload({
                        ...chart1Payload,
                        area: e.target.value
                      })
                    }
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#CBD2D9'
                      },
                      '&:hover  .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#CBD2D9'
                      },
                      '&.Mui-focused  .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#CBD2D9'
                      },
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 8
                      }
                    }}
                    renderValue={val => {
                      let value =
                        isArrayNotEmpty(metaDataArea) &&
                        metaDataArea.find((row, key) => row.pinId === val);

                      return val == 'all' ? (
                        <Typography
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            color: '#ABB4BD'
                          }}
                        >
                          Select area
                        </Typography>
                      ) : (
                        value?.area
                      );
                    }}
                  >
                    {isArrayNotEmpty(metaDataArea) &&
                      metaDataArea
                        .filter(
                          cc =>
                            cc.stateId === chart1Payload.stateId &&
                            cc.districtId === chart1Payload.districtId
                        )
                        .map((row, key) => {
                          return (
                            <MenuItem
                              key={key}
                              value={row?.pinId}
                              sx={{
                                ':hover': {
                                  backgroundColor: colorSecondary
                                }
                              }}
                            >
                              {row?.area}
                            </MenuItem>
                          );
                        })}
                  </Select>
                </FormControl>{' '}
              </Grid>{' '}
              <Grid xs={12} lg={1.9} sm={12} md={6} mr={1} mb={1}>
                <FormControl variant="outlined" fullWidth size="small">
                  <StyledSelect
                    size="small"
                    open={open == 1}
                    value={
                      open == 1
                        ? tempDateFilter.dateType
                        : chart1Payload.dateType
                    }
                    onOpen={(e, va) => {
                      setOpen(1);
                      setTempDateFilter({
                        dateType: chart1Payload.dateType,
                        startDate: chart1Payload.startDate,
                        endDate: chart1Payload.endDate
                      });
                    }}
                    onChange={e => {
                      setTempDateFilter({
                        ...tempDateFilter,
                        dateType: e.target.value,
                        startDate: null,
                        endDate: null
                      });
                    }}
                    renderValue={value => {
                      let data = open === 1 ? tempDateFilter : chart1Payload;
                      if (data.dateType == 'all') {
                        return (
                          <Typography
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              color: '#ABB4BD'
                            }}
                          >
                            <SvgIcon fontSize="small">
                              <FilterLinesIcon color="#ABB4BD" />
                            </SvgIcon>
                            Select date
                          </Typography>
                        );
                      }
                      switch (data.dateType) {
                        case 'selected_date':
                          return `${data.startDate ? dayjs(data.startDate).format('DD/MM/YY') : ''} - ${data.endDate ? dayjs(data.endDate).format('DD/MM/YY') : ''}`;
                        case 'Week':
                          return 'Last Week';
                        case 'Month':
                          return 'This Month';
                        case 'past_3_months':
                          return 'Past 3 months';
                        case 'Past_1_Year':
                          return 'Past 1 year';
                        default:
                          return;
                      }
                    }}
                    // endAdornment={
                    //   chart1Payload.dateType ? (
                    //     <IconButton
                    //       sx={{ marginRight: '10px' }}
                    //       aria-label="clear"
                    //       size="small"
                    //       onClick={() => {
                    //         setChart1Payload({
                    //           ...chart1Payload,
                    //           dateType: 'all',
                    //           startDate: null,
                    //           endDate: null
                    //         });
                    //         setTempDateFilter({
                    //           startDate: null,
                    //           dateType: null,
                    //           endDate: null
                    //         });
                    //       }}
                    //       edge="end"
                    //     >
                    //       <HighlightOff sx={{ color: '#ABB4BD' }} />
                    //     </IconButton>
                    //   ) : null
                    // }
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#CBD2D9'
                      },
                      '&:hover  .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#CBD2D9'
                      },
                      '&.Mui-focused  .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#CBD2D9'
                      },
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 8
                      }
                    }}
                  >
                    <MenuItem
                      sx={{ ...styledMenuItem, paddingX: 0 }}
                      value="selected_date"
                      disableRipple
                    >
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box display={'flex'} margin={'0px 6px'}>
                          <FormControl
                            variant="outlined"
                            fullWidth
                            size="small"
                          >
                            <DatePicker
                              name="Start-Date"
                              value={dayjs(tempDateFilter.startDate)}
                              slotProps={{
                                textField: {
                                  size: 'small',
                                  error: false,
                                  InputProps: {
                                    sx: { color: colorTextBlack }
                                  }
                                }
                              }}
                              onChange={date =>
                                setTempDateFilter({
                                  ...tempDateFilter,
                                  dateType: 'selected_date',
                                  startDate: date,
                                  endDate: date
                                })
                              }
                            />
                          </FormControl>
                          <FormControl
                            variant="outlined"
                            fullWidth
                            size="small"
                          >
                            <DatePicker
                              minDate={dayjs(tempDateFilter.startDate)}
                              label="End Date"
                              value={dayjs(tempDateFilter.endDate)}
                              slotProps={{
                                textField: {
                                  size: 'small',
                                  error: false,
                                  InputProps: {
                                    sx: { color: colorTextBlack }
                                  }
                                }
                              }}
                              onChange={date => {
                                setTempDateFilter({
                                  ...tempDateFilter,
                                  dateType: 'selected_date',
                                  endDate: date
                                });
                              }}
                            />
                          </FormControl>
                        </Box>
                      </LocalizationProvider>
                    </MenuItem>

                    <MenuItem sx={styledMenuItem} value="Week" disableRipple>
                      Last Week
                    </MenuItem>
                    <MenuItem sx={styledMenuItem} value="Month" disableRipple>
                      This Month
                    </MenuItem>
                    <MenuItem
                      sx={styledMenuItem}
                      value="past_3_months"
                      disableRipple
                    >
                      Past 3 month
                    </MenuItem>
                    <MenuItem
                      sx={styledMenuItem}
                      value="pPast_1_Year"
                      disableRipple
                    >
                      Past 1 year
                    </MenuItem>
                    <MenuItem
                      sx={{
                        border: '1px solid #E4E7EB',
                        backgroundColor: colorPrimary,
                        marginX: 1,
                        borderRadius: 3,
                        justifyContent: 'center',
                        marginY: 1,
                        '&:hover': {
                          background: colorPrimary
                        }
                      }}
                      onClick={() => {
                        if (tempDateFilter.dateType) {
                          setChart1Payload({
                            ...chart1Payload,
                            dateType: tempDateFilter.dateType,
                            startDate: tempDateFilter.startDate,
                            endDate: tempDateFilter.endDate
                          });
                        }
                        setTempDateFilter({
                          dateType: null,
                          endDate: null,
                          startDate: null
                        });
                        setOpen(null);
                      }}
                    >
                      Apply
                    </MenuItem>
                    <MenuItem
                      sx={{
                        border: '1px solid #E4E7EB',
                        backgroundColor: colorPrimary,
                        marginX: 1,
                        borderRadius: 3,
                        justifyContent: 'center',
                        marginY: 1,
                        '&:hover': {
                          background: colorPrimary
                        }
                      }}
                      onClick={() => {
                        setChart1Payload({
                          ...chart1Payload,
                          dateType: 'all',
                          startDate: null,
                          endDate: null
                        });
                        setTempDateFilter({
                          startDate: null,
                          dateType: null,
                          endDate: null
                        });
                        setOpen(null);
                      }}
                    >
                      Close
                    </MenuItem>
                  </StyledSelect>
                </FormControl>{' '}
              </Grid>
            </Grid>
          </Grid>
          <Grid item sx={{ display: 'flex', alignSelf: 'end' }}>
            <Legend
              series={
                userAndRoleAnalyticsData.analyticsData.length > 0
                  ? userAndRoleAnalyticsData.analyticsData[0]
                      .slice(1)
                      .map((name, index) => ({
                        name,
                        color: options.series[index].color
                      }))
                  : []
              }
            />
            <Tooltip title="Resize">
              <IconButton onClick={() => handleClickOpen(1)} sx={{ mx: 0.5 }}>
                <SvgIcon sx={{ height: 18, width: 18 }}>
                  <Expand05Icon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
            <Tooltip title="Download image">
              <IconButton
                onClick={() => {
                  handleDownload({ id: 1 });
                }}
                sx={{ mr: 0.5 }}
              >
                <SvgIcon sx={{ height: 18, width: 18 }}>
                  <FileDownload03Icon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs={12} mb={2}>
            {isUserAndRoleAnalyticsLoading && (
              <Skeleton height={300} width={'100%'} />
            )}
            {!isUserAndRoleAnalyticsLoading && (
              <Chart
                height={'300px'}
                width={'100%'}
                chartType="LineChart"
                data={userAndRoleAnalyticsData.analyticsData}
                options={options}
                getChartWrapper={val => {
                  setChart1Wrapper(val);
                }}
              />
            )}
          </Grid>
        </Grid>
      )}

      {chartType == 'usersChart' && (
        <Grid
          mt={2}
          container
          display={'flex'}
          width={'100%'}
          flexDirection={'column'}
          sx={{ borderRadius: '8px', padding: 2, bgcolor: 'white' }}
        >
          <Grid item display={'flex'} mb={1}>
            <Grid container display={'flex'} mb={1}>
              <Grid xs={12} lg={3} sm={12} md={6} mr={1} mb={1}>
                <FormControl fullWidth>
                  <Select
                    placeholder="User status"
                    size="small"
                    value={chart2Payload.userStatusType}
                    onChange={e =>
                      setChart2Payload({
                        ...chart2Payload,
                        userStatusType: e.target.value
                      })
                    }
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#CBD2D9'
                      },
                      '&:hover  .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#CBD2D9'
                      },
                      '&.Mui-focused  .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#CBD2D9'
                      },
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 8
                      },
                      minWidth: 200
                    }}
                    renderValue={val => {
                      return val === -999 ? (
                        <Typography
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            color: '#ABB4BD'
                          }}
                        >
                          <SvgIcon fontSize="small" sx={{ marginRight: 1 }}>
                            <User01Icon color="#ABB4BD" />
                          </SvgIcon>
                          User status
                        </Typography>
                      ) : val === true ? (
                        'Active Users'
                      ) : val === false ? (
                        'Inactive Users'
                      ) : (
                        'All Users'
                      );
                    }}
                  >
                    <MenuItem value={'all'}>All Users</MenuItem>
                    <MenuItem value={true}>Active Users</MenuItem>
                    <MenuItem value={false}>Inactive Users</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid xs={12} lg={3} sm={12} md={6} mr={1} mb={1}>
                <FormControl variant="outlined" fullWidth size="small">
                  <StyledSelect
                    size="small"
                    open={open === 2}
                    value={
                      open === 2
                        ? tempDateFilter.dateType
                        : chart2Payload.dateType
                    }
                    onOpen={(e, va) => {
                      setOpen(2);
                      setTempDateFilter({
                        dateType: chart2Payload.dateType,
                        startDate: chart2Payload.startDate,
                        endDate: chart2Payload.endDate
                      });
                    }}
                    onChange={e => {
                      setTempDateFilter({
                        ...tempDateFilter,
                        dateType: e.target.value,
                        startDate: null,
                        endDate: null
                      });
                    }}
                    renderValue={value => {
                      let data = open === 2 ? tempDateFilter : chart2Payload;

                      if (data.dateType == 'all') {
                        return (
                          <Typography
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              color: '#ABB4BD'
                            }}
                          >
                            <SvgIcon fontSize="small" sx={{ marginRight: 1 }}>
                              <FilterLinesIcon color="#ABB4BD" />
                            </SvgIcon>
                            Select date
                          </Typography>
                        );
                      }
                      switch (data.dateType) {
                        case 'selected_date':
                          return `${data.startDate ? dayjs(data.startDate).format('DD/MM/YY') : ''} - ${data.endDate ? dayjs(data.endDate).format('DD/MM/YY') : ''}`;
                        case 'Week':
                          return 'Last Week';
                        case 'Month':
                          return 'This Month';
                        case 'past_3_months':
                          return 'Past 3 months';
                        case 'Past_1_Year':
                          return 'Past 1 year';
                        default:
                          return;
                      }
                    }}
                    // endAdornment={
                    //   chart2Payload.dateType ? (
                    //     <IconButton
                    //       sx={{ marginRight: '10px' }}
                    //       aria-label="clear"
                    //       size="small"
                    //       onClick={() => {
                    //         setChart2Payload({
                    //           ...chart2Payload,
                    //           dateType: 'all',
                    //           startDate: null,
                    //           endDate: null
                    //         });
                    //         setTempDateFilter({
                    //           startDate: null,
                    //           dateType: null,
                    //           endDate: null
                    //         });
                    //       }}
                    //       edge="end"
                    //     >
                    //       <HighlightOff sx={{ color: '#ABB4BD' }} />
                    //     </IconButton>
                    //   ) : null
                    // }
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#CBD2D9'
                      },
                      '&:hover  .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#CBD2D9'
                      },
                      '&.Mui-focused  .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#CBD2D9'
                      },
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 8
                      }
                    }}
                  >
                    <MenuItem
                      sx={{ ...styledMenuItem, paddingX: 0 }}
                      value="selected_date"
                      disableRipple
                    >
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box display={'flex'} margin={'0px 6px'}>
                          <FormControl
                            variant="outlined"
                            fullWidth
                            size="small"
                          >
                            <DatePicker
                              name="Start-Date"
                              sx={{ marginRight: 1 }}
                              value={dayjs(tempDateFilter.startDate)}
                              slotProps={{
                                textField: {
                                  size: 'small',
                                  error: false,
                                  InputProps: {
                                    sx: { color: colorTextBlack }
                                  }
                                }
                              }}
                              onChange={date =>
                                setTempDateFilter({
                                  ...tempDateFilter,
                                  dateType: 'selected_date',
                                  startDate: date,
                                  endDate: date
                                })
                              }
                              components={{
                                OpenPickerIcon: props => (
                                  <IconButton size="small" {...props}>
                                    <Calendar01Icon />
                                  </IconButton>
                                )
                              }}
                            />
                          </FormControl>
                          <FormControl
                            variant="outlined"
                            fullWidth
                            size="small"
                          >
                            <DatePicker
                              minDate={dayjs(tempDateFilter.startDate)}
                              label="End Date"
                              value={dayjs(tempDateFilter.endDate)}
                              slotProps={{
                                textField: {
                                  size: 'small',
                                  error: false,
                                  InputProps: {
                                    sx: { color: colorTextBlack }
                                  }
                                }
                              }}
                              onChange={date => {
                                setTempDateFilter({
                                  ...tempDateFilter,
                                  dateType: 'selected_date',
                                  endDate: date
                                });
                              }}
                              components={{
                                OpenPickerIcon: props => (
                                  <IconButton size="small" {...props}>
                                    <Calendar01Icon />
                                  </IconButton>
                                )
                              }}
                            />
                          </FormControl>
                        </Box>
                      </LocalizationProvider>
                    </MenuItem>

                    <MenuItem sx={styledMenuItem} value="Week" disableRipple>
                      Last Week
                    </MenuItem>
                    <MenuItem sx={styledMenuItem} value="Month" disableRipple>
                      This Month
                    </MenuItem>
                    <MenuItem
                      sx={styledMenuItem}
                      value="past_3_months"
                      disableRipple
                    >
                      Past 3 month
                    </MenuItem>
                    <MenuItem
                      sx={styledMenuItem}
                      value="pPast_1_Year"
                      disableRipple
                    >
                      Past 1 year
                    </MenuItem>
                    <MenuItem
                      sx={{
                        border: '1px solid #E4E7EB',
                        backgroundColor: colorPrimary,
                        marginX: 1,
                        borderRadius: 3,
                        justifyContent: 'center',
                        marginY: 1,
                        '&:hover': {
                          background: colorPrimary
                        }
                      }}
                      onClick={() => {
                        if (tempDateFilter.dateType) {
                          setChart2Payload({
                            ...chart2Payload,
                            dateType: tempDateFilter.dateType,
                            startDate: tempDateFilter.startDate,
                            endDate: tempDateFilter.endDate
                          });
                        }
                        setTempDateFilter({
                          dateType: null,
                          endDate: null,
                          startDate: null
                        });
                        setOpen(null);
                      }}
                    >
                      Apply
                    </MenuItem>
                    <MenuItem
                      // disabled={
                      //   !(tempDateFilter.dateType || chart1Payload.dateFilter)
                      // }
                      sx={{
                        border: '1px solid #E4E7EB',
                        backgroundColor: colorPrimary,
                        marginX: 1,
                        borderRadius: 3,
                        justifyContent: 'center',
                        marginY: 1,
                        '&:hover': {
                          background: colorPrimary
                        }
                      }}
                      onClick={() => {
                        setChart2Payload({
                          ...chart2Payload,
                          dateType: 'all',
                          startDate: null,
                          endDate: null
                        });
                        setTempDateFilter({
                          startDate: null,
                          dateType: null,
                          endDate: null
                        });
                        setOpen(null);
                      }}
                    >
                      Close
                    </MenuItem>
                  </StyledSelect>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid item sx={{ display: 'flex', alignSelf: 'end' }}>
            <Tooltip title="Resize">
              <IconButton onClick={() => handleClickOpen(2)} sx={{ mx: 0.5 }}>
                <SvgIcon sx={{ height: 18, width: 18 }}>
                  <Expand05Icon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
            <Tooltip title="Download image">
              <IconButton
                onClick={() => {
                  handleDownload({ id: 2 });
                }}
                sx={{ mr: 0.5 }}
              >
                <SvgIcon sx={{ height: 18, width: 18 }}>
                  <FileDownload03Icon />
                </SvgIcon>
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs={12} mb={2}>
            <Chart
              height={'300px'}
              width={'100%'}
              chartType="LineChart"
              data={userAnalyticsData.analyticsData}
              options={options2}
              getChartWrapper={val => {
                setChart2Wrapper(val);
              }}
            />
          </Grid>
        </Grid>
      )}
      <Dialog
        sx={{ borderRadius: '8px' }}
        open={chart !== ''}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogContent sx={{ borderRadius: 10 }}>
          <Box textAlign={'end'}>
            <IconButton size="small" onClick={handleClose}>
              <SvgIcon sx={{ height: 18, width: 18 }}>
                <XClose />
              </SvgIcon>
            </IconButton>
            <Legend
              series={
                chart === 1
                  ? userAndRoleAnalyticsData.analyticsData.length > 0
                    ? userAndRoleAnalyticsData.analyticsData[0]
                        .slice(1)
                        .map((name, index) => ({
                          name,
                          color: options.series[index].color
                        }))
                    : []
                  : userAnalyticsData.analyticsData.length > 0
                    ? userAnalyticsData.analyticsData[0]
                        .slice(1)
                        .map((name, index) => ({
                          name,
                          color: options.series[index].color
                        }))
                    : []
              }
            />
          </Box>
          {chart == 1 && (
            <Chart
              height={'300px'}
              width={'100%'}
              chartType="LineChart"
              data={userAndRoleAnalyticsData.analyticsData}
              options={options}
            />
          )}
          {chart == 2 && (
            <Chart
              height={'300px'}
              width={'100%'}
              chartType="LineChart"
              data={userAnalyticsData.analyticsData}
              options={options2}
            />
          )}
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default ShareUserAndRoleAnalytics;
